import { isEmpty } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';

import Embed from 'hb-react/shared/components/DesignSystem/Embed';

const AttachedEmbed = ({ embed }) =>
  !isEmpty(embed) && (
    <Box mt={4}>
      <Embed embed={embed} />
    </Box>
  );

export default AttachedEmbed;
